<template>
  <div class="signup">
    <AuthCard
      v-if="!loading"
      title="Crie uma conta"
      subtitle="Teste grátis durante 7 dias. Não é necessário cartão de crédito."
      submit-label="Criar minha conta"
      :on-submit="register"
      :disabled="!!errors.items.length || !Object.values(form).every(Boolean)"
    >
      <Input
        v-model="form.name"
        :validate="'required'"
        name="name"
        type="text" 
        title="Nome completo"
        placeholder="Digite seu nome"
      />
      <Input
        v-model="form.username"
        :validate="'required|email'"
        name="username"
        type="text" 
        title="E-mail"
        placeholder="Digite seu e-mail"
      />
      <Input
        v-model="form.password"
        :validate="'required|min:6'"
        name="senha"
        type="password" 
        title="Senha"
        placeholder="Digite sua senha"
      />
      <template slot="error">
        <span>E-mail ou senha inválidos.</span>
      </template>

      <template slot="card-footer">
        <div class="card-footer margin-auto">
          Ao criar uma conta você concorda com nossos <a href="https://clickzap.com.br/termos-de-uso/" target="_blank">Termos de uso</a> e <a href="https://clickzap.com.br/termos-de-uso/" target="_blank">Políticas de Privacidade</a>.
        </div>
      </template>
    </AuthCard>

    <div v-if="!loading" class="help-content">
      <span>Já tem uma conta?</span>
      <a href="/auth/signin" class="help-content-action">Acesse a sua conta</a>
    </div>

    <div v-if="loading" class="auth-card">
      <Loading loading />
      <div class="auth-card-loading">
        Criando conta...
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Loading from '@/components/base/Loading'
import Input from '@/components/form/input'

import AuthCard from '@/components/pages/auth/card'

export default {
  layout: 'auth',
  components: { AuthCard, Input, Loading },
  data: () => ({
    loading: false,
    form: {
      name: '',
      username: '',
      password: ''
    }
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  mounted() {
    this.$fb.track('InitiateCheckout')
    this.$mixpanel.track('Open Register Page')

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?render=6LeCUNoUAAAAAAO24uGxPJC3CJZsGy27r3SvhyWK'
    )
    document.head.appendChild(recaptchaScript)
  },
  notifications: {
    showLoginError: {
      title: '',
      message: 'Failed to authenticate',
      type: 'error'
    }
  },
  methods: {
    ...mapActions({
      registerUser: 'registerUser',
      createZap: 'zaps/create'
    }),
    async getRecaptchaToken() {
      var recaptchaToken = ''
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6LeCUNoUAAAAAAO24uGxPJC3CJZsGy27r3SvhyWK', {
            action: 'submit'
          })
          .then(token => {
            recaptchaToken = token
          })
      })
      while (recaptchaToken == '') {
        await new Promise(r => setTimeout(r, 100))
      }
      return recaptchaToken
    },
    async register() {
      const submitForm = {}
      submitForm.email = this.form.username.trim().toLowerCase()

      this.$validator.validate().then(async valid => {
        try {
          this.loading = true

          submitForm.name = this.form.name
          submitForm.email = this.form.username.trim().toLowerCase()
          submitForm.password = this.form.password
          submitForm.username = this.form.username
          submitForm.affiliation = this.$route.query.ref
          submitForm.campaign = this.$route.query.campaign
          submitForm.token = await this.getRecaptchaToken()
          submitForm.occupation = '-'

          await this.registerUser(submitForm)
          await this.$auth.loginWith('local', { data: submitForm })

          await this.createZap({ name: 'Primeiro Zap' })

          this.$mixpanel.identify(this.$store.state.auth.user.id)
          this.$mixpanel.register({
            $user_id: this.$store.state.auth.user.id,
            Name: submitForm.name,
            Email: submitForm.email,
            Affiliation: submitForm.affiliation,
            'Ad Campaign': submitForm.campaign
          })
          this.$mixpanel.people.set({
            $user_id: this.$store.state.auth.user.id,
            $name: submitForm.name,
            $email: submitForm.email,
            Plan: 'Free Trial'
          })
          this.$mixpanel.track('Complete Registration')
        } catch (e) {
          this.loading = false
          this.showLoginError({
            message:
              e.response?.data?.message || 'Um erro ocorreu. Tente novamente.'
          })
        } finally {
          if (this.isAuthenticated) {
            try {
              document.querySelector('.grecaptcha-badge').style.display = 'none'
            } finally {
              this.$router.push({
                name: 'onboarding'
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.signup {
  width: 100%;

  &-form {
    display: flex;
    flex-direction: column;
    gap: $scale800;
    width: 100%;

    &-error {
      @include ParagraphSmall;
      color: $negative400;

      display: flex;
      align-items: center;
      gap: $scale300;

      margin: $scale600 0;
    }
  }

  .help-content {
    display: flex;
    justify-content: center;
    gap: $scale300;
    margin-top: $scale800;

    @include ParagraphSmall;
    color: $neutral500;

    &-action {
      @include ParagraphSmall;
      color: $neutral500;
      font-weight: 700;
      text-decoration: none;
      color: $blue200;
    }
  }

  .card-footer {
    @include ParagraphSmall;
    text-align: center;
    color: $neutral400;

    & > a {
      font-weight: 600;
      color: $darkBlue200;
      text-decoration: none;
    }
  }
}
</style>
